import FullCalendar from '@fullcalendar/vue'
import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/list/main.css'
export default ({ app, router, Vue }) => {
  Vue.component('full-calendar' ,FullCalendar)
}
